export const boardMeetingTour = {
  key: "boardMeeting",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-meeting-link"]',
      content: t("Tour_BoardMeeting_Link"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-meeting-settings"]',
      content: t("Tour_BoardMeeting_Settings"),
      placement: "right",
    },
    {
      target: '[data-tour="board-meeting-schedule"]',
      content: t("Tour_BoardMeeting_Schedule"),
      placement: "right",
    },
    {
      target: '[data-tour="board-meeting-invite"]',
      content: t("Tour_BoardMeeting_Invite"),
      placement: "bottom",
    },
  ],
};
